import {selectUserPanel} from '../selector'

export const getAuthorizationInfo = state => selectUserPanel(state).authorizationInfo

export const isUserRatesReadOnly = state => !getAuthorizationInfo(state).costOfWorkRatesEditable


// WEBPACK FOOTER //
// ./web/js/panels/user/authorizationInfo/selectors.js